"use client";

import { useEffect } from "react";
import { showCenteredToast } from "../action/feedback";

export function AccessToastNotifier( ) {

  useEffect(() => {
    const successMessage = localStorage.getItem("loginSuccess");
    
    if (successMessage) {
      showCenteredToast(successMessage, "success");
      localStorage.removeItem("loginSuccess"); // ✅ Rimuoviamo il messaggio dopo averlo mostrato
    }
  }, []);

  return null; // Questo componente non ha UI, serve solo per il toast
}
